import React from "react";
import {Box, Chip, Paper, Typography} from "@mui/material";
import type {Supplier360, NewsSentiment} from "../../supplier360DemoData";
import {formatDate, sentimentColor} from "../../supplier360Utils";

type Props = { supplier: Supplier360 };

const sentimentLabel: Record<NewsSentiment, string> = {
    positive: 'Positive',
    neutral: 'Neutral',
    negative: 'Negative',
};

export const NewsTab: React.FC<Props> = ({supplier}) => {
    if (supplier.news.length === 0) {
        return <Typography color="text.secondary">No recent news for this supplier.</Typography>;
    }

    return <Box>
        {supplier.news.map(n => (
            <Paper key={n.id} variant="outlined" className="s360-item-card" sx={{p: 2}}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
                    <Typography variant="h3" sx={{fontSize: 15}}>{n.headline}</Typography>
                    <Chip size="small" color={sentimentColor(n.sentiment)} label={sentimentLabel[n.sentiment]}/>
                </Box>
                <Typography variant="caption" color="text.secondary">
                    {n.source} · {formatDate(n.date)}
                </Typography>
                <Typography variant="body2" mt={1}>{n.summary}</Typography>
            </Paper>
        ))}
    </Box>;
};
